<template>
    <div class="row d-flex align-items-end">
        <div class="col-10">
            <label :for="dataFieldName">{{ label }}</label>
            <input type="text" :name="dataFieldName" v-model="value" class="form-control">
        </div>
        <div class="col">
            <div class="btn btn-secondary" @click="generateSlug">Generate slug</div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['dataFieldName'],
    data() {
        return {
            label: window[this.dataFieldName]['label'],
            value: window[this.dataFieldName]['value'],
            model_id: window[this.dataFieldName]['model_id'],
            model: window[this.dataFieldName]['model'],
        }
    },
    methods: {
        generateSlug() {
            axios
                .post("/admin/ajax/slug/generate", {
                    model_id: this.model_id,
                    model: this.model,
                    value: this.value,
                })
                .catch((error) => {
                    this.displayAlert(
                        "error",
                        "Generation failed"
                    );
                })
                .then((response) => {
                    if (response.data.success) {
                        this.displayAlert("success", "Slug successfully generated!");
                        this.value = response.data.slug;
                    } else {
                        this.displayAlert("error", "Generation failed")
                    }
                });
        }
    },
}

</script>
